import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { useNavigate } from "react-router-dom";
import AdminHeader from "../../component/AdminHeader";
const addPriceEndpoint = ApiEndpoints?.price?.priceCreate;
// const ListPriceEndpoint = ApiEndpoints.price.priceList;

export default function AddPrice() {
  const navigate = useNavigate();
  const [draggedPlanPointIndex, setDraggedPlanPointIndex] = useState(null);
  const [pricing, SetPricing] = useState({
    starting_up_monthly_cost: "",
    starting_up_yearly_cost: "",
    professional_monthly_cost: "",
    professional_yearly_cost: "",
    expert_monthly_cost: "",
    expert_yearly_cost: "",
    plan_points: [
      {
        point: "",
        starting_up: "",
        professional: "",
        expert: "",
        // super_app: ""
      }
    ],

    faqs: [
      { question: "", answer: "" },
      { question: "", answer: "" },
    ]
  });


  const handleExtraFeatureChange = (field, value) => {
    SetPricing(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // const handlePlanPointChange = (index, field, value) => {
  //   SetPricing(prev => {
  //     const updated = { ...prev };
  //     updated.plans[0].plan_points[index][field] = value;
  //     return updated;
  //   });
  // };

  const handlePlanPointChange = (index, field, value) => {
    SetPricing(prev => ({
      ...prev,
      plan_points: prev.plan_points.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      )
    }));
  };

  // const addPlanPoint = () => {
  //   SetPricing(prev => {
  //     const updated = { ...prev };
  //     updated.plans[0].plan_points.push({
  //       point: "",
  //       starting_up: "",
  //       professional: "",
  //       expert: "",
  //       // super_app: ""
  //     });
  //     return updated;
  //   });
  // };

  const addPlanPoint = () => {
    SetPricing(prev => ({
      ...prev,
      plan_points: [
        ...prev.plan_points,
        {
          point: "",
          starting_up: "",
          professional: "",
          expert: "",
        }
      ]
    }));
  };

  // const removePlanPoint = (index) => {
  //   SetPricing(prev => {
  //     const updated = { ...prev };
  //     updated.plans[0].plan_points.splice(index, 1);
  //     return updated;
  //   });
  // };


  const removePlanPoint = (index) => {
    SetPricing(prev => ({
      ...prev,
      plan_points: prev.plan_points.filter((_, i) => i !== index)
    }));
  };

  const movePlanPoint = (fromIndex, toIndex) => {
    if (fromIndex === toIndex || fromIndex === null || toIndex === null) return;

    SetPricing(prev => {
      const planPoints = [...prev.plan_points];
      const [movedPoint] = planPoints.splice(fromIndex, 1);
      planPoints.splice(toIndex, 0, movedPoint);
      return {
        ...prev,
        plan_points: planPoints
      };
    });
  };

  const handlePlanPointDragStart = (e, index) => {
    setDraggedPlanPointIndex(index);
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", String(index));
  };

  const handlePlanPointDrop = (e, index) => {
    e.preventDefault();
    const fromIndex = draggedPlanPointIndex ?? Number(e.dataTransfer.getData("text/plain"));
    movePlanPoint(fromIndex, index);
    setDraggedPlanPointIndex(null);
  };


  const validatePricing = (pricing) => {
    if (
      !pricing.starting_up_monthly_cost.trim() ||
      !pricing.starting_up_yearly_cost.trim() ||
      !pricing.professional_monthly_cost.trim() ||
      !pricing.professional_yearly_cost.trim() ||
      !pricing.expert_monthly_cost.trim() ||
      !pricing.expert_yearly_cost.trim()
    ) {
      return false;
    }

    for (const point of pricing.plan_points) {
      if (!point.point.trim()) return false;
      for (const key of ["starting_up", "professional", "expert"]) {
        const value = point[key];
        if (value === "") return false;

        if (value === "content" || (typeof value === "string" && value !== "true" && value !== "false")) {
          if (!value.trim() || value === "content") {
            return false;
          }
        }
      }
    }

    return true;
  };


  //  useEffect(() => {
  //     const fetchPrice = async () => {
  //       try {
  //         const response = await ApiRequest("GET", ListPriceEndpoint);
  //         SetPricing(response?.plans || []);
  //       } catch (error) {
  //         console.error("Failed to fetch Price:", error);
  //         SetPricing([]);
  //       }
  //     };
  //     fetchPrice();
  //   }, []);


  // 🔹 handle change for question/answer
  const handleFaqChange = (index, field, value) => {
    SetPricing(prev => ({
      ...prev,
      faqs: prev.faqs.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      )
    }));
  };

  // 🔹 add new FAQ
  const addFaq = () => {
    SetPricing(prev => ({
      ...prev,
      faqs: [...prev.faqs, { question: "", answer: "" }]
    }));
  };

  const removeFaq = (index) => {
    SetPricing(prev => ({
      ...prev,
      faqs: prev.faqs.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validatePricing(pricing)) {
      toast.error("All fields are mandatory!");
      return;
    }

    const formData = new FormData();
    Object.entries(pricing).forEach(([key, value]) => {
      if (key === "faqs" || key === "plan_points") {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, value);
      }
    });


    try {
      const response = await ApiRequest("POST", addPriceEndpoint, formData);
      if (response.error === true) {
        toast.error(response.message)
      } else {
        toast.success(response.message)
        navigate("/price");
      }
    } catch (error) {
      console.error("There was an error creating the price!", error);
      alert("There was an error creating the Pricing!");
    }
  };

  const pagename = {
    name: ' Pricing Management',
    user: 'Admin',
    innerpage: 'Pricing Management / Pricing / Add Pricing'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-content-page">
        <form id="blogAdd" onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div class="col-lg-12">
                    <h3 className="heading-text"> Extra Plans </h3>
                  </div>

                  <div className="row">
                    <div className="col-lg-4">
                      <div className="add-page-inputs">
                        <div className="label-wrap-add">
                          <label>Starting Up Monthly Cost<small>*</small></label>
                        </div>
                        <input type="number" name="starting_up_monthly_cost" required className="form-control"
                          value={pricing.starting_up_monthly_cost} onChange={(e) =>
                            handleExtraFeatureChange("starting_up_monthly_cost", e.target.value)} />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="add-page-inputs">
                        <div className="label-wrap-add">
                          <label>Starting Up Yearly Cost<small>*</small></label>
                        </div>
                        <input type="number" name="starting_up_yearly_cost" required className="form-control"
                          value={pricing.starting_up_yearly_cost} onChange={(e) =>
                            handleExtraFeatureChange("starting_up_yearly_cost", e.target.value)} />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="add-page-inputs">
                        <div className="label-wrap-add">
                          <label>Professional Monthly Cost<small>*</small></label>
                        </div>
                        <input type="number" name="professional_monthly_cost" required className="form-control"
                          value={pricing.professional_monthly_cost} onChange={(e) =>
                            handleExtraFeatureChange("professional_monthly_cost", e.target.value)} />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="add-page-inputs">
                        <div className="label-wrap-add">
                          <label>Professional Yearly Cost<small>*</small></label>
                        </div>
                        <input type="number" name="professional_yearly_cost" required className="form-control"
                          value={pricing.professional_yearly_cost} onChange={(e) =>
                            handleExtraFeatureChange("professional_yearly_cost", e.target.value)} />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="add-page-inputs">
                        <div className="label-wrap-add">
                          <label>Expert Monthly Cost<small>*</small></label>
                        </div>
                        <input type="number" name="expert_monthly_cost" required className="form-control"
                          value={pricing.expert_monthly_cost} onChange={(e) =>
                            handleExtraFeatureChange("expert_monthly_cost", e.target.value)} />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="add-page-inputs">
                        <div className="label-wrap-add">
                          <label>Expert Yearly Cost<small>*</small></label>
                        </div>
                        <input type="number" name="expert_yearly_cost" required className="form-control"
                          value={pricing.expert_yearly_cost} onChange={(e) =>
                            handleExtraFeatureChange("expert_yearly_cost", e.target.value)} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div class="col-lg-12">
                    <h3 className="heading-text"> Plan Points </h3>
                  </div>

                  {pricing.plan_points.map((pointObj, index) => (
                    <div key={index} className="plan-point-box add-content-wrap " onDragOver={(e) => e.preventDefault()} onDrop={(e) => handlePlanPointDrop(e, index)}>
                      <div className="col-lg-12">
                        <div className="add-page-inputs">
                          <div className="label-wrap-add d-flex justify-content-between align-items-center">
                            <label>Plan Point {index + 1}<small>*</small></label>
                            <button
                              type="button"
                              draggable
                              onDragStart={(e) => handlePlanPointDragStart(e, index)}
                              onDragEnd={() => setDraggedPlanPointIndex(null)}
                              className="btn btn-sm btn-outline-secondary"
                              style={{ cursor: "grab" }}
                            >
                              Drag
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="add-page-inputs">
                          <div className="label-wrap-add">
                            <label>Point Name:<small>*</small></label>
                          </div>
                          <input type="text" className="form-control" value={pointObj.point} onChange={(e) =>
                            handlePlanPointChange(index, "point", e.target.value)} />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="add-page-inputs ">
                          <div className="row">
                            {/* Dropdowns for the four plan fields */}
                            {["starting_up", "professional", "expert"].map((field) => {
                              const value = pointObj[field];
                              const dropdownValue = value === true ? "true" : value === false ? "false" : value === "" ? "" : "content";
                              return (

                                <div key={field} className="col-md-6">
                                  <div className="add-page-inputs">
                                    <div className="label-wrap-add">
                                      <label>{field.replace("_", " ") + ""}:<small>*</small></label>
                                    </div>
                                    <select className="form-control" value={dropdownValue}
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        if (val === "true") handlePlanPointChange(index, field, true);
                                        else if (val === "false") handlePlanPointChange(index, field, false);
                                        else if (val === "content") handlePlanPointChange(index, field, "content");
                                        else handlePlanPointChange(index, field, "");
                                      }}
                                    >
                                      <option value="">select</option>
                                      <option value="true">True</option>
                                      <option value="false">False</option>
                                      <option value="content">Content</option>
                                    </select>
                                    {/* Show input only if "content" is selected */}
                                    {dropdownValue === "content" && (
                                      <input type="text" className="form-control mt-1" placeholder={`Enter ${field} content`} value={typeof value === "string" && value !== "content" ? value : ""} onChange={(e) =>
                                        handlePlanPointChange(index, field, e.target.value)} />
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>

                        {/* Remove button top right */}
                        {pricing.plan_points.length > 1 && (
                          <button type="button" className="remove-btn" onClick={() => removePlanPoint(index)}>
                            Remove
                          </button>
                        )}

                      </div>
                    </div>
                  ))}
                  <div className="col-lg-12">
                    <div className="add-page-inputs">
                      <button type="button" onClick={addPlanPoint} className="addmore-images-client" style={{ width: "100%", }} >
                        Add More +
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div className="add-content-wrap">
            <h5>Faq Section</h5>
            <div className="row">
              {pricing.faqs.map((faq, index) => (
                <div key={index} className="col-lg-6" style={{ position: "relative" }}>
                  <div className="add-content-wrap">
                    <div className="add-page-inputs input-add-image">
                      <div className="label-wrap-add">
                        <label>Question<small>*</small></label>
                      </div>
                      <input required className="form-control" type="text" placeholder={`Question ${index + 1}`} value={faq.question} onChange={(e) => handleFaqChange(index, "question", e.target.value)} />
                    </div>
                    <div className="add-page-inputs input-add-image">
                      <div className="label-wrap-add">
                        <label>Answer<small>*</small></label>
                      </div>
                      <input required className="form-control" placeholder={`Answer ${index + 1}`}
                        value={faq.answer} onChange={(e) => handleFaqChange(index, "answer", e.target.value)} />
                    </div>
                    {index >= 2 && (
                      <button type="button" style={{ position: "absolute", background: "linear-gradient(270deg,#e20814,#a80008)", top: "5px", right: "10px", color: "#fff", border: "none", borderRadius: "8px", fontSize: "12px", padding: "3px 15px" }} onClick={() => removeFaq(index)}>
                        REMOVE
                      </button>
                    )}
                  </div>
                </div>
              ))}
              <div className="col-lg-12 text-center">
                <div className="add-page-inputs">
                  <button type="button" className="addmore-images-client" onClick={addFaq} style={{ width: "100%", }}  >
                    Add New Faq
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
        <button type="submit" form="blogAdd" className="default-btn">Publish <span></span></button>
      </div>
    </>
  );
}
